const initialState = {
  // reviews: [
  //   {
  //     id: '1',
  //     content: 'Делаем ВНЖ уже второй раз,первый опыт был не совсем удачный, поэтому решили обратиться к ребятам в Hiljuris по рекомендации. Взяли тариф все включено,очень рады, не нужно было возиться с бумагами самим)))Как итог, виза на 3 года!!! Ура)',
  //     author: 'Ольга Басалай',
  //     country: 'Беларусь',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '2',
  //     content: 'Очень рады, что обратились в эту фирму, сделали все на отлично. Нам делали много всего: песель, мельдунок, внж. Екатерина очень приятная девушка, рекомендуем)',
  //     author: 'Анна Колосей',
  //     country: 'Грузия',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '3',
  //     content: 'Обращались за помощью для подачи внж, помогли подготовить все документы, нам осталось только сходить в ужонд. Для нас идеальный вариант. Спасибо.',
  //     author: 'Алексей Кивако',
  //     country: 'Беларусь',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '4',
  //     content: 'Благодаря HilJuris я легально обосновался в Польше без лишних хлопот. Их команда профессионалов справилась с моими юридическими вопросами на высшем уровне. Рекомендую!',
  //     author: 'Юрий Коренюк',
  //     country: 'Беларусь',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '5',
  //     content: 'HilJuris - надежный партнер в легализации в Польше. Они помогли мне оформить все необходимые документы и сделали процесс простым и понятным. Очень доволен результатом.',
  //     author: 'Татьяна Лютич',
  //     country: 'Беларусь',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '6',
  //     content: 'Сотрудничество с HilJuris превзошло все мои ожидания. Их эксперты помогли мне пройти через сложные процедуры легализации, предоставив профессиональную поддержку на каждом этапе. Очень рекомендую!',
  //     author: 'Владимир Копыльчук',
  //     country: 'Украина',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '7',
  //     content: 'HilJuris - надежная компания, которая знает все тонкости и требования в сфере легализации в Польше. Спасибо им за оперативность, профессионализм и индивидуальный подход',
  //     author: 'Дарья Бороденко',
  //     country: 'Украина',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '8',
  //     content: 'С HilJuris я получил надежную поддержку в процессе легализации. Их команда помогла мне оформить все документы в сжатые сроки и всегда была готова ответить на мои вопросы. Огромное им спасибо!',
  //     author: 'Ярослав Пасько',
  //     country: 'Украина',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '9',
  //     content: 'HilJuris - моя лучшая находка! Они были настолько грамотны и профессиональны, что весь процесс превратился в лёгкую задачу. Рекомендую всем, кто ищет надёжного партнера',
  //     author: 'Виктор Корнейчук',
  //     country: 'Украина',
  //     photo: './img/profilePhoto.jpg'
  //   },
  //   {
  //     id: '10',
  //     content: 'Я безмерно благодарен HilJuris за их помощь в легализации в Польше. Их команда экспертов оказала непревзойдённую поддержку, внимательно рассмотрев мою ситуацию и предоставив индивидуальное решение. Очень доволен результатом!',
  //     author: 'Олег Хрекул',
  //     country: 'Украина',
  //     photo: './img/profilePhoto.jpg'
  //   },
  // ],

  advantages: [
    {
      id: '1',
      description: 'Высокое качество услуг',
    },
    {
      id: '2',
      description: 'Экспертиза в польском законодательстве',
    },
    {
      id: '3',
      description: 'Поддержка на всех этапах',
    },
    {
      id: '4',
      description: 'Оперативность',
    },
    {
      id: '5',
      description: 'Прозрачность',
    },
    {
      id: '6',
      description: 'Конкурентные цены',
    },
    {
      id: '7',
      description: 'Широкий спектр юридических услуг',
    },
    {
      id: '8',
      description: 'Полная конфиденциальность',
    },
  ],

  posts: [
    /* {
      id: '28',
      title: '',
      shortDescription: '',
      content: `
      
      `,
      publishedDate: new Date('2023-11-07'),
      image: '/img/postsImages/post22.jpg',
    }, */
    {
      id: '27',
      title: 'Необычные способы легализации пребывания в Польше: волонтёрство',
      shortDescription: '',
      content: `
Легализация пребывания в Польше - это сложный процесс, который может занять много времени и сил. Однако существует множество способов легализоваться в Польше, и не обязательно выбирать самый распространенный вариант.

В Польше существует возможность получить вид на жительство на основании волонтерской деятельности. Это может быть интересно для людей, которые хотят не только помочь другим, но и получить возможность легально находиться в стране в течение определенного периода.

🔸️В соответствии с законом об иностранцах, волонтер - это иностранец, который добровольно и без вознаграждения, за исключением возмещения расходов или выплаты карманных денег, выполняет определенные действия (услуги) в рамках участия в программе Европейской волонтерской службы в пользу организации, которая была утверждена Министром Внутренних дел для приема иностранцев в качестве волонтеров. Список таких организаций можно найти на сайте Министерства Внутренних дел и Администрации в Польше.
Например, в Варшаве можно найти волонтерские возможности в следующих организациях:

▪️Fundacja Czas Wolności

▪️Fundacja Domy Serca

▪️Stowarzyszenie Promocji Wolontariatu

⏳️Разрешение на временное проживание выдается на срок, необходимый для реализации цели пребывания иностранца на территории Польши, превышающий 3 месяца, но не более 1 года, с возможностью подачи заявления на получение последующих разрешений.

💸Одним из важных условий для получения ВНЖ на основании волонтерства является наличие достаточных средств для обеспечения себя на время пребывания в Польше. Это означает, что иностранец должен иметь на своем банковском счете сумму, достаточную для оплаты проживания, питания и других расходов.

❗️Важно: данное разрешение не может быть выдано гражданам Украины и другим гражданам третьих стран и лицам без гражданства, которые прибыли в Польшу после 24 февраля 2022 г. и получили временную или международную защиту в Польше.

🤝Если вы хотите продлить своё легальное пребывание в Польше, но не уверены, на каком основании это лучше сделать, обращайтесь к нам. Наши юристы помогут вам найти подходящее основание для вашего пребывания в Польше.
      `,
      publishedDate: new Date('2023-12-23'),
      image: '/img/postsImages/post27.jpg',
    },
    {
      id: '26',
      title: 'Доверенное лицо',
      shortDescription: '',
      content: `
Кто может быть моим доверенным лицом в административных вопросах в Польше?

Вашим доверенным лицом может быть любое дееспособное лицо, достигшее возраста 18 лет. Это не обязательно должен быть адвокат или юрист. Доверенность должна быть оформлена в письменной форме, в форме электронного документа или представлена для протокола. Оригинал такой доверенности должен быть приобщен к материалам дела, то есть сдан в канцелярию органа, рассматривающего дело, или отправлен по почте. При подаче доверенности необходимо также оплатить гербовый сбор в размере 17 злотых. Гербовый сбор перечисляется на счет гмины или городского управления, где находится соответствующий орган.

Кто может назначить доверенное лицо?

Вы можете назначить доверенное лицо в ходе любого разбирательства в административных органах. Однако это не означает, что вы вообще не должны участвовать в разбирательстве. Есть процессы, которые не сделает за вас доверенное лицо. Например, заявления на получение временного/постоянного вида на жительство должны быть поданы лично вами (из-за необходимости снятия отпечатков пальцев).

Каковы последствия назначения доверенного лица?

Назначение доверенного лица означает, что это лицо будет представлять вас в административных органах. Оно будет получать всю корреспонденцию по вашему делу, в том числе и окончательные решения, подавать документы и ходатайства.
Важно помнить, что представитель несёт большую ответственность за свои действия и он должен информировать вас о каждой информации по делу, которую он получает. Если ваш представитель не будет выполнять свои обязанности, вы можете понести негативные последствия. Например, если представитель не сообщит вам о письме от органа, то все негативные последствия отсутствия ответа на письмо будут вменяться в вину вам, а не вашему доверенному лицу. Поэтому очень важно быть уверенным в добросовестности вашего представителя.

Могу ли я отказаться от услуг своего представителя?

Да, вы можете отказаться от услуг своего представителя в любое время. Для этого необходимо уведомить об этом орган, в котором ведется разбирательство, а также сообщить представителю о своем отказе.

🚨Если вы потеряли доверие к своему представителю или не можете связаться с ним в течение некоторого времени, прекратите действие его доверенности как можно скорее. В такой ситуации также свяжитесь с органом власти и ознакомьтесь с материалами вашего дела, чтобы выяснить, в каком состоянии оно находится.

Выбор доверенного лица - очень серьезное решение

Представитель может предпринимать любые действия по вашему делу. Например, он/она имеет право отозвать ваше заявление о выдаче разрешения на временное проживание без вашего ведома, обжаловать негативное решение, даже не уведомив вас об этом или наоборот не подать обжалование во время, что приведет к потере возможности подать обжалование вовсе.


Именно поэтому перед тем, как назначить доверенное лицо, внимательно проверьте его полномочия и репутацию. Убедитесь, что он обладает необходимыми знаниями и опытом, чтобы представлять ваши интересы в административных органах. 

❌Мошенники в сфере легализации пребывания иностранцев
В последнее время участились случаи мошенничества в сфере легализации пребывания иностранцев в Польше. Мошенники выдают себя за юристов и адвокатов, обещают легализовать пребывание иностранцев за небольшую плату, но на деле используют их данные для получения прибыли или совершения других противоправных действий.
Чтобы избежать этого, обращайтесь к настоящим специалистам, которые обладают необходимыми знаниями и опытом в этой области. 

🔒🤝Наши юристы понимают всю ответственность, возложенную на них, и сделают всё возможное, чтобы ваше дело успешно закончилось.
      `,
      publishedDate: new Date('2023-12-04'),
      image: '/img/postsImages/post26.jpg',
    },
    {
      id: '25',
      title: 'Польша для двоих: легализация пребывания партнера',
      shortDescription: '',
      content: `
Иногда в жизни возникают ситуации, когда люди, состоящие в серьёзных отношениях без регистрации брака, сталкиваются с трудностями при легализации своего пребывания в Польше. Если один из партнёров не может найти себе основание для легализации, то он/a может подать заявление о легализации пребывания на основании серьёзных отношений.

🔒Требования
Чтобы легализовать пребывание на основании отношений, необходимо, чтобы партнер имел право на легальное пребывание в Польше или был гражданином этой страны. Срок разрешения на временное проживание будет напрямую зависеть от срока права пребывания партнера в Польше и не может превысить его. Если партнер является гражданином Польши, то максимальный срок разрешения составит 3 года. Кроме того, партнер должен иметь достаточный доход для обеспечения вас и покрытия всех необходимых расходов.

📁Документы
Помимо стандартного пакета документов, необходимо предоставить доказательства, подтверждающие ведение семейной жизни в смысле Конвенции о защите прав человека и основных свобод. Это могут быть совместные фотографии; договор аренды или покупки совместного жилья; письменные заявления людей, которые знают о ваших отношениях; и другие документы, подтверждающие наличие действительных и постоянных тесных личных связей, характеризующихся взаимным интересом, привязанностью и зависимостью.

Документами, подтверждающими наличие источника стабильного и регулярного дохода, достаточного для покрытия расходов на проживание себя и находящихся на иждивении членов семьи, а также партнёра, может быть, например, договор ренты, заключенный между партнерами в форме нотариального акта, налоговые декларации, справки из социального страхования и т.д.

🚫Отсутствие права на работу
Важно отметить, что данный вид разрешения на временное проживание не даёт права на работу без дополнительного разрешения на работу (мы уже писали посты на эту тему).

✅Заключение
Легализация пребывания на основании отношений является одним из возможных способов легализации пребывания в Польше для иностранцев, находящихся в серьезных отношениях с гражданином или иностранцем, у которого есть право на пребывание в Польше. Однако для успешного получения разрешения необходимо предоставить веские доказательства, подтверждающие ведение семейной жизни.
      `,
      publishedDate: new Date('2023-11-26'),
      image: '/img/postsImages/post25.jpg',
    },
    {
      id: '24',
      title: 'Необоснованное лишение статуса UKR ',
      shortDescription: '',
      content: `
Уже довольно продолжительное время граждане Украины жалуются на задержку выплат пособий на воспитание детей и других социальных выплат в связи с потерей статуса "UKR".

🔸️В некоторых случаях утрата статуса происходила несмотря на непрерывное пребывание в Польше.
Омбудсмен Польши вновь занялся этой проблемой. Он обратился к президенту Фонда социального страхования (ZUS) с запросом о мерах по обеспечению бесперебойной обработки заявлений о возобновлении выплаты этих пособий. Согласно прошлому выступлению омбудсмена, причины данной проблемы не выявлены.

Офисы (urzędy), занимающиеся оформлением PESEL, в ответ на аналогичные жалобы о лишении граждан Украины статуса UKR подготовили следующие рекомендации:

▪️при пересечении границы между Польшей и Украиной каждый раз нужно просить пограничника подтвердить в проездных документах (паспортах), что граница была пересечена;

▪️по возвращении в Польшу проверить, указан ли правильный статус в государственных документах.

В случае возникновения сомнений следует лично обратиться в муниципальные органы, имея при себе документы, подтверждающие пересечение границы.

В свою очередь, Пограничная служба Польши публикует следующее сообщение по данному вопросу:

▪️граждане Украины, возвращающиеся в Польшу, должны информировать сотрудников пограничной службы во время проверки паспортов о своем въезде в Польшу в связи с использованием временной защиты и каждый раз предъявлять электронный документ diia.pl

▪️во избежание потери статуса UKR PESEL в связи с выездом с территории Польши на срок менее 30 дней, иностранный гражданин, возвращающийся в Польшу, должен сообщить сотруднику пограничной службы, осуществляющему паспортный контроль, о намерении въехать в Польшу в связи с использованием права временной защиты в Польше и каждый раз предъявлять электронный документ diia.pl (даже если путешественник едет на работу в Польшу или с другой целью, но в то же время будет использовать защиту в Польше).

▪️Важно! Въезд на территорию Польши без информирования о вышеуказанных обстоятельствах или без предъявления электронного документа diia.pl может привести к тому, что данные иностранца не будут внесены в реестры, на основании которых предоставляется статус PESEL UKR, связанный с многочисленными социальными правами([источник](https://www.strazgraniczna.pl/pl/aktualnosci/11258,Komunikat-dla-osob-posiadajacych-status-PESEL-UKR.html)). Если в описанной выше ситуации, несмотря на выяснение ситуации и доказательство наличия статуса UKR, вам отказывают в выплате пособия, следует иметь в виду, что такое решение может быть обжаловано президенту Фонда социального страхования (Prezes ZUS) в течение 14 дней с момента вручения решения. Впоследствии решение президента может быть также обжаловано в краевом административном суде в течение 30 дней с момента вынесения решения.
`,
      publishedDate: new Date('2023-11-12'),
      image: '/img/postsImages/post24.jpg',
    },
    {
      id: '23',
      title: 'Разрешение на работу типа А',
      shortDescription: '',
      content: `
Разрешение на работу типа А является наиболее распространенным типом разрешения на работу в Польше. Оно выдается иностранцу, который выполняет работу на территории Польши, на основании договора с организацией (работодателем), чей юридический адрес, место жительства или филиал, завод или другая форма организованной деятельности находятся на территории Польши.

Для получения разрешения типа А важно, чтобы:

  ▪️Размер заработной платы, которая будет указана в договоре с иностранцем, не была ниже платы работников, выполняющих работу сопоставимого вида или на сопоставимой должности;

  ▪️размер ежемесячной заработной платы иностранца не может быть ниже размера минимального вознаграждения за труд, установленного законом;

  ▪️работодатель должен иметь справку от уполномоченного органа об отсутствии возможности удовлетворения кадровой потребности работодателя на основании регистров безработных и ищущих работу граждан (тест рынка труда или информация старосты).

✅Подача заявления

Заявление о выдаче разрешения на работу подаётся работодателем в воеводское управление (urzęd wojewódzki) по юридическому адресу главного офиса фирмы или по адресу постоянного проживания работодателя.
Процедура получения разрешения на работу занимает около 30 дней и, как правило, предваряется получением информации старосты (также называемой тестом рынка труда или заключением старосты) в районном центре занятости (выдача этого документа занимает от 14 до 21 дней).

📅Срок действия и стоимость

Разрешение типа А выдаётся на срок до 3 лет и может быть продлено по просьбе работодателя. Стоимость получения этого документа составляет 50 злотых (в случае поручения работы иностранцу на срок не более трех месяцев) или 100 злотых (в случае поручения работы иностранцу на срок более трех месяцев). Продление разрешения стоит 25 и 50 злотых соответственно. Заявление о продлении разрешения на работу подается не ранее чем за 90 дней и не позднее чем за 30 дней до истечения срока действия действующего разрешения на работу.

📄Документы
Получение разрешения на работу предполагает принятие административного решения, поэтому перечень документов, необходимых для подачи заявления, достаточно широк. К заявлению требуется приложить как документы, которые касаются самого иностранца, так и документы, касающийся работодателя.
После получения разрешения на работу работодатель обязан предоставить один экземпляр разрешения на работу иностранцу, к которому это разрешение относится.
`,
      publishedDate: new Date('2023-11-06'),
      image: '/img/postsImages/post23.jpg',
    },
    {
      id: '22',
      title: 'Разрешение на работу для иностранцев в Польше: декларация поручения выполнения работы',
      shortDescription: '',
      content: `
Для того чтобы работать в Польше, граждане других стран обычно должны получить разрешение на работу. Одним из видов таких разрешений является декларация поручения выполнения работы иностранцу (oświadczenie o powierzeniu wykonywania pracy cudzoziemcowi). Существуют исключения от этого обязательства, но о них мы поговорим в будущих постах.

Для кого подходит декларация❓️

Декларация подходит только для граждан Армении, Беларуси, Грузии, Молдовы и Украины. Граждане других стран должны получить разрешение на работу.
Кроме того, декларацию нельзя получить, если работа относится к сезонным работам, а размер вознаграждения иностранного гражданина будет ниже вознаграждения работников, выполняющих работу аналогичного характера или на аналогичной должности.

Что такое сезонная работа❓️

Сезонная работа - это работа, выполняемая в течение не более 9 месяцев в календарном году в отраслях, которые обозначены как таковые в законодательстве, например, сельское хозяйство, садоводство, туризм и т.д.

Декларация имеет ряд преимуществ по сравнению с другими видами разрешений на работу:

  ▪️Процедура оформления декларации довольно быстрая. Декларацию должны зарегистрировать в течение 7 рабочих дней и только в редких случаях она может занимать до 30 дней (в случае дополнительного расследования);

  ▪️Для регистрации декларации не требуется получать сведения от старосты (informacja starosty);

  ▪️На основании декларации работодатель может нанять иностранца на срок до 24 месяцев.

Как получить декларацию❓️

Работодатель должен подать заявление о регистрации декларации в центр занятости (urząd pracy) по юридическому адресу главного офиса фирмы или месту постоянного проживания работодателя, а также предоставить необходимые документы, такие как: подтверждение оплаты гос. пошлины (100 зл.), скан проездного документа иностранца и т.д.

Заключение ✅

Декларацию поручения выполнения работы - это удобный и быстрый способ получить разрешение на работу для иностранцев. Декларация не требует вынесения административного решения, что значительно упрощает весь процесс рассмотрения. Она подходит для работодателей, которые хотят нанять иностранцев на срок до 24 месяцев. По истечении срока действия декларации работодатель сможет зарегистрировать новую декларацию для продолжения легального сотрудничества. 
      `,
      publishedDate: new Date('2023-10-28'),
      image: '/img/postsImages/post22.jpg',
    },
    {
      id: '20-21',
      title: 'ЕС продлил временную защиту для украинских беженцев',
      shortDescription: '',
      content: `
4 октября 2023 года Евросоюз продлил действие механизма временной защиты для украинских беженцев до 4 марта 2025 года❗️

Это решение было принято по предложению Европейской комиссии, которая 19 сентября 2023 года предложила продлить механизм временной защиты для украинских граждан ещё на один год.

Механизм временной защиты был активирован 4 марта 2022 года, сразу после начала вторжения в Украину. Он позволяет украинским гражданам и другим лицам, имеющим право на постоянное проживание в Украине, получить временную защиту в странах ЕС. Эта защита включает в себя право на проживание, работу, доступ к образованию и здравоохранению.

🔸️Решение о продлении защиты до 2025 года было принято в связи с тем, что война в Украине продолжается и неясно, когда она закончится. Это решение позволит обеспечить безопасность и стабильность для более чем четырех миллионов украинских беженцев, которые сейчас проживают в ЕС.

Вот основные положения решения Совета Европейского союза о продлении защиты украинцам:

▪️Срок действия механизма временной защиты для украинцев продлевается с 4 марта 2024 года по 4 марта 2025 года,

▪️граждане Украины, которые уже получили статус временной защиты, смогут продлить его на один год,

▪️новые заявления о предоставлении временной защиты будут рассматриваться до 4 марта 2025 года.


Это решение является важным шагом в поддержке украинских беженцев в Евросоюзе. Оно позволит им продолжать жить и работать в странах ЕС, пока война в Украине не закончится.

Решение ЕС о временной защите для украинских беженцев - это общий документ, который устанавливает минимальные стандарты для всех стран ЕС. Страны могут адаптировать это решение в своем национальном законодательстве, чтобы оно соответствовало их конкретным потребностям.

В Польше, например, был принят специальный закон о помощи украинским беженцам. Этот закон более подробно описывает, как украинские беженцы могут получить доступ к жилью, работе, образованию и здравоохранению в Польше.
Более подробную информацию о том, как решение ЕС о временной защите влияет на национальное законодательство в Польше.

Решение Совета ЕС о продлении временной защиты для украинских беженцев до 2025 года тесно связано с принятым ранее в Польше специальным законом о помощи украинским беженцам.

🔸️Специальный закон был принят 12 марта 2022 года, почти сразу после начала вторжения в Украину. Он предоставляет украинским беженцам право на проживание, работу, образование, здравоохранение в Польше и т.д. Решение ЕС о продлении временной защиты подтверждает, что Польша продолжит оказывать поддержку украинским беженцам. Оно также позволяет Польше продолжать применять свой специальный закон, который был разработан для удовлетворения потребностей украинских беженцев в краткосрочной перспективе.

Вот некоторые ключевые аспекты, которые связывают решение ЕС и специальный закон Польши:

  ▪️оба документа предоставляют украинским беженцам право на проживание, работу, образование и здравоохранение,

  ▪️оба документа были приняты в ответ на вторжение в Украину,

  ▪️оба документа направлены на обеспечение безопасности и стабильности для украинских беженцев.

Однако между решением ЕС и специальным законом Польши также есть некоторые различия. Решение ЕС является более общим и применимо ко всем странам ЕС. Специальный закон Польши является более конкретным и разработан специально для удовлетворения потребностей украинских беженцев в Польше.
В целом, решение ЕС о продлении временной защиты является важным шагом в поддержке украинских беженцев в Польше. Оно позволяет Польше продолжать применять свой специальный закон и оказывать помощь украинским беженцам в краткосрочной и долгосрочной перспективе.

Вот некоторые возможные последствия решения ЕС для специального закона Польши:

  ▪️Польша может продлить действие своего специального закона до 2025 года.

  ▪️Польша может внести изменения в свой специальный закон, чтобы он соответствовал решению ЕС.

  ▪️Польша может разработать новые законы или программы, чтобы поддержать украинских беженцев в долгосрочной перспективе.

Точное влияние решения ЕС на специальный закон Польши будет зависеть от дальнейших действий Польши.
      `,
      publishedDate: new Date('2023-10-08'),
      image: '/img/postsImages/post20-21.jpg',
    },
    {
      id: '19',
      title: 'Прописка - meldunek',
      shortDescription: '',
      content: `
Прописка в Польше: как это работает❓️

В Польше каждый человек, независимо от гражданства, обязан зарегистрироваться по месту проживания. Это касается как временного, так и постоянного места жительства. Регистрироваться однако не нужно, если пребывание в Польше не продлится более 30 дней.

Как зарегистрироваться❓️

Для регистрации необходимо обратиться в местный муниципалитет (urząd gminy). Заявление можно подать лично или через доверенное лицо. Несовершеннолетних детей могут зарегистрировать родители или опекуны.

Какие документы нужны❓️

Для регистрации необходимо предоставить следующие документы:

  ▪️Заявление о регистрации (можно скачать на сайте муниципалитета или заполнить уже на месте при подаче);

  ▪️Документ, удостоверяющий личность;

  ▪️Документ, подтверждающий право на пребывание в Польше (виза, карта побыту, временное удостоверение личности иностранца и т.д.);

  ▪️Документ, подтверждающий право на занятие помещения, в котором вы хотите зарегистрироваться (это может договор аренды жилья, выписка из реестра земельных участков и т.д. Если у вас нет договора и вы не являетесь владельцем жилья, то ниже будет информация, что делать в таком случае).

🔸️Стоимость регистрации

Услуга регистрации предоставляется бесплатно. Однако за свидетельство о регистрации необходимо заплатить 17 злотых.

Какие сроки рассмотрения заявления❓️

Заявление о регистрации должно быть рассмотрено сразу после подачи и если все необходимые условия соблюдены - вас должны зарегистрировать безотлагательно.

🔸️Дополнительные сведения

  ▪️Если у вас нет договора аренды жилья, но вы проживаете в данном помещении, вы можете зарегистрироваться, предоставив письменное подтверждение владельца квартиры или другого лица, имеющего право собственности на жилье, а также выписку из реестра земельных участков (чтобы показать, кто является законным владельцем недвижимости).

  ▪️Если у вас нет никаких документов, подтверждающих ваше проживание в данном помещении, вы можете зарегистрироваться, предоставив письменное объяснение причин отсутствия документов. Муниципалитет проведет расследование, чтобы подтвердить ваше проживание в данном помещении и если он подтвердит это, то вас зарегистрируют.
      `,
      publishedDate: new Date('2023-10-03'),
      image: '/img/postsImages/post19.jpg',
    },
    {
      id: '18',
      title: 'Проездной документ',
      shortDescription: '',
      content: `
Сегодня мы поговорим о польском проездном документе для иностранцев.

Что это такое❓️
Проездной документ — это временная замена постоянного удостоверения личности (паспорта), который может быть выдан иностранцам и апатридам.

Как получить проездной документ❓️

Чтобы получить проездной документ, необходимо обратиться в Управление по делам иностранцев своей области (Wydział Spraw Cudzoziemców Wojewódzkiego Urzędu) с пакетом документов, таких как:

  ▪️заявление;

  ▪️фотография 35 на 45 мм;

  ▪️документ, подтверждающий личность и гражданство;

  ▪️копия разрешения на пребывание;

  ▪️прописка (zameldowanie);

  ▪️подтверждение оплаты госпошлины;

  ▪️другие документы, подтверждающие ситуацию, которые в каждом случае будут индивидуальны (например, письменный отказ посольства вашей страны в возможности сделать новый паспорт, подтверждение статуса апатрида и т.д.).

Кто может получить проездной документ❓️

Проездной документ может быть выдан иностранцам, если:

-их национальный паспорт утерян, поврежден или истёк срок действия и нет возможности оформить новый;

-они имеют разрешение на постоянное пребывание или пребывание долгосрочного резидента ЕС или дополнительную защиту или согласие на пребывание в связи с гуманитарными причинами.

Важно❗️

С 1 июля 2023 года для граждан Беларуси сделали исключение и они могут получить такой проездной документ также на основании временного вида на жительства. Кроме того, для них получение такого документа освобождается от госпошлины (в обычном случае получение такого документа стоит 350 злотых). Стоит также подчеркнуть, что детям белорусской национальности, которые никогда ещё не получали паспорт, тоже можно будет сделать такой проездной документ. На данный момент такое исключение действует только до 31 декабря 2023 года.

🔸️Срок действия проездного документа

Проездной документ выдается на 1 год. На это время он может заменить ваш паспорт и вы сможете пересекать границу (только помните о визовом обязательстве, если это актуально в вашем случае).
      `,
      publishedDate: new Date('2023-09-22'),
      image: '/img/postsImages/post18.jpg',
    },
    {
      id: '17',
      title: 'Обжалование решений',
      shortDescription: '',
      content: `
Сегодня мы обсудим обжалование негативных решений первой административной инстанции.

🔸️Согласно административному кодексу, решение, вынесенное первой инстанцией, можно обжаловать. Стандартно на обжалование решения есть 14 дней от дня получения решения, но иногда этот срок составляет всего 7 дней (например, в случае выдачи решения об обязательном возвращении в страну происхождения). Если обжалование не подать в указанный срок, оно станет окончательным.
Орган, принимающий решение, должен сообщил вам, можете ли вы его оспаривать, сколько у вас есть на это времени, и какой орган будет рассматривать ваше обжалование.
Обычно обжалование подается через орган, решение которого вы обжалуете. В последующем орган самостоятельно отправит обжалование высшей инстанции со всеми актами по вашему делу.

❗️Важно уточнить, что если орган даёт неверную информацию о процедуре обжалования или вовсе не предоставляет её, это не может причинить вреда стороне, которая следовала этому указанию. Это означает, что если вы следуете неверной информации и подадите, например, обжалование позже, чем нужно было, орган власти должен рассмотреть его без необходимости ходатайствовать о восстановлении срока.

Что может сделать орган во второй инстанции❓️

  ▪️оставить решение без изменений,

  ▪️отменить решение полностью или частично и вынести новое,

  ▪️отменить решение и закрыть дело,

  ▪️отменить решение и отправить дело на повторное рассмотрение в первую инстанцию.

🔸️Исключения, когда обжалование недопустимо:

Есть несколько случаев, когда обжалование невозможно. Например, если решение первой инстанции полностью соответствовало вашим запросам (этот закон вступил в силу только в мае 2023 года). Также решение, принятое министром или апелляционной коллегией местного самоуправления (польское: samorządowe kolegium odwoławcze), не подлежит обжалованию, но можно обратиться в этот орган для пересмотра дела. Существуют и другие решения, которые нельзя обжаловать согласно отдельным законам, например, решение президента о предоставлении польского гражданства. Если вам в этом отказали, обжаловать это решение нельзя.
Также помните, что после изменений в законе об иностранцах в 2023 году некоторые сроки на обжалование сократились, а в некоторых случаях даже изменились уполномоченные органы для рассмотрения обжалований.

Статья основана на: Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.
      `,
      publishedDate: new Date('2023-09-03'),
      image: '/img/postsImages/post17.jpg',
    },
    {
      id: '16',
      title: 'Трудовой договор с испытательным сроком',
      shortDescription: '',
      content: `
Сегодня мы расскажем о трудовом договоре с испытательным сроком (umowa o pracę na okres próbny), который так часто предлагают новым сотрудникам их работодатели. Речь пойдет именно о трудовом договоре, который регулируется прежде всего трудовым кодексом.

🔸️Испытательный срок - это период, когда работодатель и работник могут определить, подходит ли им сотрудничество.
Это выгодно для обеих сторон: вы можете узнать, подходит ли вам политика компании, коллектив, условия и т.д., как и компания может оценить вашу совместимость и навыки. По истечении испытательного срока для обеих сторон остаётся, как правило, открытый путь к продлению контракта или отказу от дальнейшего сотрудничества.

📆 Изменения в 2023 году

Договор с испытательным сроком по-прежнему, как правило, не может длиться более 3 месяцев. Важным изменением в трудовом кодексе стало то, что работодатель с первого дня работы сотрудника должен знать, на какой срок он будет принят на работу в будущем. Трудовой договор с испытательным сроком заключается на срок, не превышающий:

  ▪️ 1 месяца - в случае намерения заключить договор на срок менее 6 месяцев;

  ▪️ 2 месяца - в случае намерения заключить договор на срок не менее 6 месяцев и не более 12 месяцев;

  ▪️ 3 месяца - в случае намерения заключить договор не менее одного года или заключить договор на неопределенный срок.

🔄 Важно: теперь договор с испытательным сроком может быть заключен повторно между тем же работодателем и работником, но только на другой должности или для другого вида деятельности. Это относится к договорам независимо от срока, прошедшего с момента прекращения предыдущих трудовых отношений. Это отличная возможность для работников и потенциальных улучшений.

📝 Продление испытательного срока

Стало возможно продление испытательного срока более трёх месяцев, но только при определенных условиях, которые обсуждаются и соглашаются при подписании договора. Срок такого договора может быть продлён, например, на время отпуска, больничного или иной уважительной причины отсутствия работника на работе.
      `,
      publishedDate: new Date('2023-08-27'),
      image: '/img/postsImages/post16.jpg',
    },
    {
      id: '15',
      title: 'Распространенные ошибки при подаче документов на ВНЖ',
      shortDescription: '',
      content: `
Давайте поговорим о частых причинах, из-за которых человек может получить отрицательное решение по разрешению на временное проживание. Эти ошибки вполне возможно избежать. Рассмотрим некоторые наиболее распространенные из них.

1️⃣ Использование устаревших форм заявлений

Для подачи заявления на временное проживание требуется использовать соответствующую форму, которая устанавливается министром внутренних дел. Форму нельзя составлять самостоятельно. Во избежание ошибки, рекомендуем использовать возможность заполнить заявление в электронной форме. Для Мазовецкого воеводства это можно сделать на сайте: https://inpol.mazowieckie.pl/

2️⃣ Несвоевременная подача заявления

Важно подать заявление не позднее последнего дня легального проживания на территории Польши. Есть лишь несколько исключительных ситуаций, когда заявление можно подать даже после окончания легального статуса. Если вы не можете записаться на личную подачу до окончания вашего легального срока пребывания, вы можете подать заявление через biuro podawcze или отправьте его по почте. В случае отправки почтой, день отправки считается днем подачи.

3️⃣ Недостоверные данные или ложь в заявлении

Важно всегда предоставлять точную информацию в заявлении, даже если она кажется вам “невыгодной”. Если во время административного процесса выяснится, что данные не соответствуют действительности, орган имеет право отказать вам в получение разрешения на проживание. Кроме того, ваша подпись под заявлением подразумевает, что данные являются достоверными, и ложь или утаивание какой-то информации может повлечь за собой уголовную ответственность.

4️⃣ Незаверенные копии документов

Орган рассматривает только заверенные копии приложенных документов. Для заверения копий можно воспользоваться услугами нотариуса или заверить документы при личной подаче заявления после предварительной записи! При подаче документов через biuro podawcze копии документов заверить нельзя. Если оригиналы каких-то документов вам не нужны, то можно предоставить органу их (в таком случае заверять копии не будет нужно). 

5️⃣ Неправильно заполненное Приложение №1

Если цель вашего пребывания в Польше – работа и проживание, ваш работодатель должен заполнить специальное приложение. Заявитель не может заполнять это приложение самостоятельно. Оно также должно быть подписано полным именем и фамилией подписавшего и содержать количество рабочих часов в неделю (в случае umowy zlecenia).

6️⃣ Не указание актуального адреса для корреспонденции

Важно помнить, что орган имеет право связаться с вами не только через электронную почту или телефон, но и обычной почтой. Если вы не получите письмо от органа вовремя, он не обязан искать другие способы связи. Если ваш адрес изменился во время процесса, не забудьте сразу уведомить об этом орган.
      `,
      publishedDate: new Date('2023-08-12'),
      image: '/img/postsImages/post15.jpg',
    },
    {
      id: '14',
      title: 'Сроки рассмотрения дел',
      shortDescription: '',
      content: `
Давайте разберемся в вопросе административных сроков рассмотрения дел.

🔸️Согласно административному кодексу, государственные органы обязаны оперативно рассматривать дела без необоснованных задержек. Именно поэтому в некоторых случаях, которые не требует дополнительной проверки, органы выдают своё решение ещё в день подачи заявления. Даже если у органа законодательно есть несколько месяцев на рассмотрение дела, ему нельзя откладывать дело до последнего дня, так как это нарушает статьи административного кодекса.

Административные сроки можно поделить на две категории:

  ▪️сроки из административного кодекса,

  ▪️сроки, установленные в специальных законах для конкретных процедур.

Рассмотрим основные сроки в процедурах согласно административному кодексу. Дела, не требующие дополнительных проверок, должны быть рассмотрены сразу же после подачи заявления. Дела, требующие проверки, должны быть рассмотрены в течение одного месяца, а особо сложные дела - в течение двух месяцев после начала процесса. Дела, по которым была подана апелляция, рассматриваются в течение одного месяца с момента получения апелляции.

🔸️Давайте разберем пример, который интересует многих - сроки рассмотрения разрешения на временное проживание в Польше. До начала 2022 года считалось, что разрешение на временное проживание (и в последующем выдача карты побыта, польское: karta czasowego pobytu), можно рассмотреть согласно статьям административного кодекса - от одного до двух месяцев.

С началом 2022 года ситуация изменилась❗️

В январе 2022 года вступил в силу закон, устанавливающий срок в 60 дней для рассмотрения заявления на разрешение временного проживания (не включая время на изготовление пластика в случае положительного решения). Таким образом, законодатель увеличил сроки рассмотрения дел, автоматически узнав все дела по ВНЖ как особо сложные.

Важно заметить, что эти 60 дней начинают отсчитываться с момента подачи заявления, не содержащего формальных недостатков, или со дня устранения этих недостатков. Поэтому часть ответственности за соблюдение срока рассмотрения дела лежит на самом заявителе и (если оно есть) на его доверенном лице. Тем не менее, государственный орган не освобождается от обязанности провести формальную проверку правильности оформления заявления иностранца в течение общего установленного срока, т.е. в течение одного месяца или двух месяцев с момента подачи.

Всегда, когда орган не успевает рассмотреть дело в указанные сроки, он должен сообщить вам о причинах задержки и предполагаемой новой дате рассмотрения дела. Если задержка неприемлема, вы можете обратиться в высшую инстанцию или в суд.

Мы понимаем, что органы не всегда следуют установленным срокам. Наша команда юристов поможет вам решить этот вопрос! :) 

Статья основана на: Ustawa z dnia 12 grudnia 2013 r. o cudzoziemcach oraz ustawie z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego
      `,
      publishedDate: new Date('2023-08-04'),
      image: '/img/postsImages/post14.jpg',
    },
    {
      id: '13',
      title: 'Статус беженца и убежище. В чём разница ?',
      shortDescription: '',
      content: `
Часто понятия “статус беженца” и получение “убежища” (польское: azyl) путают. Так произошло, ведь нам логически кажется, что человек со статусом беженца получает убежище, а значит эти понятия означают одно и то же. Давайте разъясним разницу между ними.

🔸️С точки зрения закона, это разные понятия и процедуры.

Статус беженца - это одна из форм международной защиты (подробнее вы можете прочитать об этом в наших предыдущих постах). Человеку с таким статусом формально предоставляется защита, а не убежище.

Убежище, в свою очередь, является формой национальной польской защиты.

Чтобы получить убежище, необходимо удовлетворить два критерия:

  ▪️ получение убежища необходимо для обеспечения вашей защиты и

  ▪️речь идет о государственных интересах Польши, которые носят политический характер.

🔸️Должны быть соблюдены оба эти критерия, именно поэтому количество людей, получающих убежище, гораздо меньше, чем статус беженца. Если ежегодно орган выдает около 11 тысяч решений по предоставлению международной защиты, то по предоставлению убежища речь идёт скорее лишь о нескольких единицах.

Так как критерии для убежища могут толковаться широко, нет постоянного каталога более конкретных требований. В доктрине однако наиболее распространенной является точка зрения, согласно которой основанием для предоставления убежища является факт (или вероятность) политически мотивированного преследования, причем квалификация политического характера мотивации преследования относится исключительно к государственным органам страны преследуемого. Кроме того, решение должно быть проверено с точки зрения важных интересов Республики Польша. Решение о предоставлении статуса беженца и убежища выдаёт один и тот же административный орган, то есть Глава Управления по делам иностранцев.

Важно однако уточнить, что для предоставления убежища требуется ещё согласие Министра иностранных дел. Это требование также даёт основание утверждать, что убежище служит политическим интересам государства, предоставившего убежище. Вероятно, по этой причине данный правовой институт используется крайне редко. 

Кроме вышеперечисленного, важным отличием от международной защиты является то, что заявление на предоставление убежища может быть подано как во время пребывания в Польше, так и за её пределами. Форма такого заявления не предписана - оно может быть написано от руки или на компьютере. Главное, чтобы в заявлении были указаны данные заявителя, страна его происхождения и обоснование запроса на получение убежища в Польше.

Заявитель должен пройти процедуру снятия отпечатков пальцев, а также согласиться на фотографирование. Если человек находится за границей, фотография должна быть сделана им самим и уже по прибытию на территорию Польши он должен будет пройти процедуру снятия отпечатков пальцев.

Статья основана на законе -  ustawa z dnia 13 czerwca 2003 r. o udzielaniu cudzoziemcom ochrony na terytorium Rzeczypospolitej Polskiej и научной публикации: B. Kowalczyk: “Polski system azylowy”, Wrocław 2014 r. 
      `,
      publishedDate: new Date('2023-07-31'),
      image: '/img/postsImages/post13.jpg',
    },
    {
      id: '11-12',
      title: 'Гостевое приглашение',
      shortDescription: '',
      content: `
Кто может сделать гостевое приглашение в Польшу❓

Многие думают, что только граждане Польши могут сделать гостевое приглашение, но это не так. Это только один из вариантов.
Кроме граждан Польши, гостевое приглашение могут сделать:

  ▪️rраждане государств-членов Европейского Союза, Европейской ассоциации свободной торговли (ЕАСТ) или Швейцарской Конфедерации, а также члены их семей, проживающие в Польше с правом пребывания или постоянного пребывания на этой территории,

  ▪️иностранцы, которые получили разрешение на постоянное проживание (посл.: karta stalego pobytu) или разрешение на проживание для долгосрочного резидента ЕС,

  ▪️юридические лица или организационные единицы без статуса юридического лица, имеющие местонахождение в Польше (посл.: jednostka organizacyjna nieposiadająca osobowości prawnej; не относиться к ИП!),

  ▪️иностранцы, проживающие легально и непрерывно на территории Польши не менее 5 лет перед выдачей приглашения (что значит непрерывно было описано в предыдущем посте).
Давайте разберем последний пункт более подробно, так как он вызывает наибольшее количество вопросов. Чтобы удовлетворить этот критерий, вы должны прожить в Польше не менее 5 лет на любом легальном основании, таком как виза, ВНЖ или любое другое разрешение на пребывание. В зависимости от вашей конкретной ситуации, вам потребуются документы, подтверждающие ваше легальное пребывание, такие как решение о разрешении на временное пребывание, ксерокопии паспорта с визами и т.д.

🔸️Важно отметить, что приглашающий несет полную ответственность за иностранца, которого он приглашает. Поэтому помимо вышеперечисленных условий, приглашающее лицо должно иметь средства для покрытия расходов, связанных с пребыванием иностранца в Польше и его возвращением, предоставлять жилье на время пребывания и т.д.

Расходы на проживание и питание, выделенные на каждого приглашенного  иностранца, составляют не менее 515 злотых за каждый месяц его пребывания в Польше. Если приглашаемый иностранец является близким родственником, например, родителем, бабушкой/дедушкой, ребенком, родным братом/сестрой, супругом приглашающего и т.д., сумма должна составлять не менее 200 злотых в месяц на каждого приглашенного родственника. Важно отметить, что при расчёте ваших доходов и расходов, нужно посчитать также себя и всех людей на вашем иждивении. 
Приведем пример: вы содержите своего супруга и 2 несовершеннолетних детей, а ваша заработная плата в месяц составляет 4000 зл нетто. Получается, что от 4000 зл вы автоматически отнимать 515 зл за себя и 1545 зл (515 x 3 за каждого члена семьи на иждивении). Итого, 4000 зл - 2060 зл = 1940 зл у вас останется для покрытия расходов иностранцев, которых вы хотите пригласить.

Дополнительно к указанной в прошлом посте сумме расходов на проживание и питание, необходимо учесть расходы на обратную дорогу приглашенного иностранца в страну его происхождения или проживания:

- 200 злотых в случае обратной поездки или транзита в соседние с Польшей страны (Беларусь, Украина, Российская Федерация)

- 500 злотых в случае обратной поездки или транзита в европейскую страну, не указанную выше,

- 2 500 злотых в случае обратной поездки или транзита в неевропейскую страну.

Обязательство обеспечить финансовое покрытие на обратную дорогу считается выполненным, если приглашающее лицо предоставит доказательства наличия у иностранца билета обратного возвращения.

Для подтверждения наличия финансовых средств можно предоставить следующие документы:

свежая распечатка банковского счета с указанием остатка на счете (сделанная не ранее чем за 30 дней до подачи заявления),

справка о трудоустройстве с указанием размера ежемесячного дохода и типа трудового договора,

решение о величине пенсии или пособия.

Если расходы на приглашенного иностранца покрываются совместно с супругом, необходимо предоставить письменное согласие супруга на покрытие расходов, а также документы, подтверждающие его материальное положение.

Приглашающее лицо также должно обеспечить иностранца жильём. Для этого могут быть предоставлены следующие документы:

- документ, подтверждающий право собственности на жильё или выписка из земельного кадастра (полс. księga wieczysta);

- право на кооперативное жильё (полс. przydział lokalu spółdzielczego);

- договор аренды жилья. В случае приложения договора аренды жилья, которое не является государственной или муниципальной собственностью, следует приложить документы арендодателя на право владения этим жильём, а также его письменное согласие на проживание в нём приглашенного иностранца;


Также возможно предоставление другого места проживания для иностранца, например, брони отеля. В таком случае бронь должна содержать информацию о том, кто и на какой период забронировал номер.

Жилая площадь помещения, предоставляемого для проживания иностранца, должна составлять не менее 7 м2 на каждого зарегистрированного в помещении лица и на каждого приглашенного иностранца. Данное условие не применяется, если приглашаемое лицо является близким родственником приглашающего лица (в таком случае необходимо документально подтвердить степень родства).

Обратите внимание, что указанная выше информация применима для физических лиц. Требования для юридических лиц и других будут иными.

Государственный сбор на июль 2023 г. за одного приглашенного составляет 27 зл.

Статья основана на законе: Ustawa z dnia 12 grudnia 2013 r. o cudzoziemcach. 
      `,
      publishedDate: new Date('2023-07-23'),
      image: '/img/postsImages/post11-12.jpg',
    },
    {
      id: '10',
      title: 'Непрерывное пребывание',
      shortDescription: '',
      content: `
Часто в процедурах легализации можно встретить требование “непрерывное пребывание”. Но что означает это "непрерывное пребывание" ❓️

Давайте разберёмся.

Когда в основаниях для получения разрешения на проживание упоминается "непрерывное" (полс. nieprzerwany pobyt), это не означает, что вы не можете покидать Польшу в течение 5 или даже 10 лет. Обычно под "непрерывным" пребыванием подразумевается определение из статьи 195 пункта 4 закона об иностранцах. Согласно этому определению, пребывание считается непрерывным, если ваше отсутствие за пределами Польши не превышает 6 месяцев за раз и общая сумма отсутствия за пределами Польши не превышает 10 месяцев. То есть, если в условиях получения разрешения на пребывание указано непрерывное пребывания в течение напр. 5 лет, то за эти 5 лет вы не можете суммарно отсутствовать в Польше более 10 месяцев, а ваш единичный выезд не может длиться более 6 месяцев. Если это условие нарушено, необходимо начать отсчет требуемого "непрерывного" времени пребывания сначала.

🔸️Однако есть исключения из этого правила. Если вы покинули Польшу по причине:

1️⃣ работы (командировки) на основании договора с работодателем, зарегистрированным в Польше, или

2️⃣ сопровождения иностранца, указанного в пункте 1, в качестве его/её супруга/и или несовершеннолетнего ребенка,

— ваше отсутствие будет обоснованным.

Аналогичной будет ситуация, когда вы выехали в другую страну с целью прохождения стажировки или участия в занятиях, предусмотренных курсом обучения в польском высшем учебном заведении. То есть, если вы напр. поступили в заграничный университет самостоятельно, это не будет считается исключением, так как не предусмотрено польским учебным заведением.

Кроме того, существует законодательное исключение, которое не ограничивается определенным перечнем. Это особая личная ситуация, которая продолжается не более 6 месяцев и требует присутствия иностранца за пределами Польши. К такой ситуации может относиться выезд из-за болезни, госпитализации, беременности или других важных обстоятельств.  Каждая ситуация будет рассматриваться индивидуально, поэтому рекомендуется документировать эти обстоятельства, чтобы ваше пребывание считалось непрерывным, даже если общая продолжительность отсутствия превысит 10 месяцев.

Статья основана на законе: Ustawa z dnia 12 grudnia 2013 r. o cudzoziemcach
      `,
      publishedDate: new Date('2023-07-09'),
      image: '/img/postsImages/post10.jpg',
    },
    {
      id: '9',
      title: 'Отмена состояния эпидемиологической угрозы в Польше',
      shortDescription: '',
      content: `
1 июля 2023 года Министерство здравоохранения официально отменяет состояние угрозы эпидемии.

Почему это важно знать❓️

До 31 июля 2023 года ещё есть время, чтобы уладить свою юридическую ситуацию в Польше и не попасть в неприятное положение❗️

Отмена состояния эпидемиологической угрозы означает также отмену специальных "ковидных" положений, которые регулировали правила продления документов на проживание. Это повлияет на юридическую ситуацию множество людей, особенно в отношении следующих документов:

▪️ визы (национальные и Шенген);

▪️ разрешения на временное проживание и karty czasowego pobytu, включая выданные другими государствами-членами ЕС;

▪️карты долгосрочного резидента ЕС;

▪️ временные удостоверения личности для иностранцев;

▪️карты временного пребывания членов семьи граждан ЕС и т.д.

Кроме того, продление сроков на подачу заявления о легализации пребывания в Польше, легальное пребывание в рамках безвизового режима и добровольный выезд с территории Польши станет недействительным.

🔸️Успейте подать заявление на легализацию своего пребывания в Польше до 31 июля 2023 года.

Статья основана на законе: Rozporządzenie Ministra Zdrowia z dnia 14 czerwca 2023 r. w sprawie odwołania na obszarze Rzeczypospolitej Polskiej stanu zagrożenia epidemicznego
      `,
      publishedDate: new Date('2023-07-02'),
      image: '/img/postsImages/post9.jpg',
    },
    {
      id: '7-8',
      title: '',
      shortDescription: 'Польское гражданство',
      content: `
Существует несколько способов получения польского гражданства. В соответствии со статьей 4 закона о польском гражданстве, гражданство Польши можно получить:

  1. 'ex lege' (в результате действия закона),

  2. в результате предоставления польского гражданства (nadanie obywatelstwa polskiego),

  3. путем признания польским гражданином (uznanie za obywatela polskiego).

🔸️Существует также возможность восстановить польское гражданство, но это совсем другая процедура и относится только к тем, кто уже когда-то был гражданином Польши.

Получение польского гражданства 'ex lege' относиться только к несовершеннолетним и возможно, если:

  ▪️хотя бы один родитель является гражданином Польши;

  ▪️ребенок родился на территории Республики Польша, а его родители неизвестны, не имеют польского гражданства или их гражданство не определено;

  ▪️ребенок был найден на территории Республики Польша, а его/ее родители неизвестны;

  ▪️ребенок был усыновлен лицом или лицами, имеющими польское гражданство, а полное усыновление произошло до достижения им/ею 16-летнего возраста.

Приобретение польского гражданства 'ex lege' (в результате действия закона) означает, что не нужно подавать специальное заявление для признания ребенка гражданином Польши и ждать решения от соответствующего органа. Если ребёнок соответствует одному из вышеперечисленных критериев, он может быть признан польским гражданином.

Второй способ получения польского гражданства - обращение к Президенту РП, который может предоставить гражданство иностранцам по своему усмотрению. 
Одним из главных преимуществ такого способа является то, что абсолютно любой совершеннолетний иностранец может подать заявление и получить гражданство (за несовершеннолетних детей заявление подают их родители или официальные опекуны). Не имеет значения, на каком основании иностранец находится в Польше (и находится ли вообще на территории страны, так как даже это не является обязательным условием), есть ли у него источник дохода и знает ли он польский язык. Единственное требование - подать соответствующее заявление губернатору (wojewoda) или польскому консулу, которые в свою очередь передадут его Президенту РП. Заявление также можно отправить по почте.

Минусом этой процедуры является то, что она законодательно практически не регулируется. У Президента нет обязательных сроков рассмотрения заявления, поэтому в практике оно занимает обычно не менее 2 лет. Кроме того,  в случае отрицательного решения нет возможности обжалования, а значит решение Президента является окончательным. Это не означает, что невозможно получить гражданство другим путем, но в этой процедуре больше ничего нельзя будет сделать.

🔸️Если вы являетесь совершеннолетним и хотите получить польское гражданство, то рекомендуем обратить внимание именно на этот способ, так как его критерии довольно понятно урегулированы в законе, а значит есть более высокие шансы предсказать решение и время его выдачи первой инстанцией. В случае задержки или получения негативного решения со стороны органа, существуют правовые способы изменить ситуацию, в отличие от процедуры получения гражданства через Президента РП.

Признать польским гражданином могут иностранца, который проживает на территории Польши на основании разрешения на постоянное проживание или разрешения на проживание для долгосрочного резидента ЕС (в подпунктах будет идти речь именно об этих разрешениях), а также:

  ▪️пребывает непрерывно на территории РП не менее 3 лет на основании одного из разрешений, имеет стабильный и регулярный источник дохода в Польше, а также законное право на занятие жилого помещения (напр. аренда, собственность квартиры и т.д.);

  ▪️пребывает непрерывно на территории РП не менее 2 лет на основании одного из разрешений, а также состоит в браке не менее 3 лет с гражданином Польши;

  ▪️пребывает непрерывно на территории РП не менее 2 лет на основании одного из разрешений и не имеет никакого гражданства;

  ▪️является несовершеннолетним и пребывает на территории РП на основании одного из разрешений и один из его/eё родителей является гражданином Польши, а другой родитель, не являющийся гражданином Польши, дал согласие на такое признание;

  ▪️пребывает непрерывно и легально на территории РП не менее 10 лет (не важно, на каком именно основании, главное, чтобы легально), имеет одно из разрешений (не важно, как долго), а также имеет стабильный и регулярный источник дохода в Польше и законное право на занятие жилого помещения.

Кроме этого, признать польским гражданина могут иностранца, который:

  ▪️непрерывно пребывает на территории РП не менее 2 лет на основании разрешения на постоянное проживание, полученного в связи с предоставлением статуса беженца в Республике Польша;

  ▪️постоянно пребывает на территории РП не менее одного года на основании разрешения на постоянное проживание, полученного в связи с польским происхождением или наличием Карты поляка.

  ▪️Иностранец, ходатайствующий о признании польским гражданином, за исключением несовершеннолетнего, обязан владеть польским языком, подтвержденным официальным сертификатом с уровнем владения языком не ниже B1 или свидетельством об окончании школы в Республике Польша или свидетельством об окончании школы за рубежом с польским языком обучения.

Статья основана на законе: Ustawa z dnia 2 kwietnia 2009 r. o obywatelstwie polskim
      `,
      publishedDate: new Date('2023-07-02'),
      image: '/img/postsImages/post7-8.jpg',
    },
    {
      id: '6',
      title: 'Дополнительная защита',
      shortDescription: '',
      content: `
Дополнительная защита - это один из двух видов международной защиты (далее как: межд. защита). Она предоставляется тем, кто не соответствует условиям для получения статуса беженца (о чём мы писали ранее), но возвращение в страну происхождения может подвергнуть его/её реальному риску причинения серьезного вреда.

О таком риске мы можем говорить, когда:

1️⃣ человеку грозит:

  ▪️Вынесение смертного приговора;

  ▪️Казнь;

  ▪️Пытки;

  ▪️Бесчеловечное или унижающее достоинство обращение или наказание;

2️⃣ существует серьезная и индивидуальная угроза жизни или здоровью в результате широкомасштабного применения насилия против гражданских лиц в ситуации международного или внутреннего вооруженного конфликта,
- и из-за этой угрозы вы не можете или не хотите воспользоваться защитой вашей страны происхождения.

Название "дополнительная защита" говорит само за себя. Изначально существовал только один вид межд. защиты - статус беженца. Но потом было понято, что не все люди подходят под это определение, хотя объективно они находятся в очень сложной жизненной ситуации. Таким образом, было принято решение создать институцию дополнительной защиты, которая рассматривается автоматически при отрицательном решении в получении статуса беженца. Нет необходимости отдельно подавать заявление на получение дополнительной защиты.

🔸️Одно из главных отличий дополнительной защиты от статуса беженца заключается в том, что не требуется доказывать индивидуальную угрозу в стране происхождения из-за преследования. Достаточно того, что на всей территории страны происходит вооруженный конфликт, который сам по себе представляет серьезную и индивидуальную угрозу для жизни или здоровья каждого человека, находящегося на этой территории.

Вид предоставленной межд. защиты также влияет на выдаваемые в будущем документы:

  ▪️Беженцам выдают карту побыта и женевский паспорт, который заменяет проездной документ страны происхождения (паспорт).
  
  ▪️Лица, которым предоставлена дополнительная защита, также получают карту побыта, но сохраняют свой проездной документ страны происхождения и не получают женевский паспорт.

Статья основана на законе - Ustawa z dnia 13 czerwca 2003 r. o udzielaniu cudzoziemcom ochrony na terytorium Rzeczypospolitej Polskiej.
      `,
      publishedDate: new Date('2023-06-21'),
      image: '/img/postsImages/post6.jpg',
    },
    {
      id: '5',
      title: 'Статус беженца',
      shortDescription: '',
      content: `
Кто такой беженец в понимании польского законодательства?

🔸️Беженец - это человек, который был вынужден покинуть страну своего происхождения из-за преследований, которым он подвергался или потенциально может подвергнуться. А также он/она не может рассчитывать на защиту своей страны или не желает её использовать из-за страха преследования. Такие люди могут получить статус беженца - один из видов международной защиты.

В законодательстве описан конкретный каталог объективных причин преследования, а именно:

▪️раса,

▪️религия,

▪️национальность,

▪️политические убеждения,

▪️принадлежность к определенной социальной группе.

Этот каталог причин является закрытым. Это означает, что если человек чувствует себя преследуемым по любой другой причине, то ему не будет предоставлен статус беженца. Но это не означает, что в Польше не будет предоставлена никакая защита вообще, так как существуют и другие виды защиты, напр. дополнительная
защита, разрешение на пребывание по гуманитарным причинам и т.д.

С преследованием мы имеем дело, когда действие (сумма каких-то действий) или бездействие приводит к нарушению наших основных прав человека, таких как право на жизнь, свободу от рабства, пыток,и т.д. Важно отметить, что возможная смерть в результате законных военных действий не будет рассматриваться как преследование в рамках данной процедуры (акцент на слово “законных”). Преследование может осуществляться как физическими лицами, так и государственными органами или организациями. Возбуждение уголовного дела или вынесение приговора, которые являются несоразмерными или дискриминационными, также могут рассматриваться как преследование в контексте предоставления международной защиты.

Существуют ситуации, когда обоснованные опасения преследования возникают уже после того, как человек покинул страну. Например, во время выезда из страны произошел государственный переворот, в результате которого этническое меньшинство, к которому человек принадлежит, подвергается преследованиям. В таких случаях представители этого этнического меньшинства также имеют право на получение статуса беженца. Важно подчеркнуть, что орган может отказать в предоставлении статуса беженца, если иностранец основывает свой страх преследования на обстоятельствах, которые им/ей намеренно созданы после выезда из страны происхождения, например, намеренное размещение негативной информации о властях страны происхождения на общедоступных интернет-порталах. 

Статья основана на законе - Ustawa z dnia 13 czerwca 2003 r. o udzielaniu cudzoziemcom ochrony na terytorium Rzeczypospolitej Polskiej  и комментарию к этому закону.
      `,
      publishedDate: new Date('2023-05-22'),
      image: '/img/postsImages/post5.jpg',
    },
    {
      id: '4',
      title: 'Разрешение на временное пребываение (ВНЖ)',
      shortDescription: '',
      content: `
В большинстве случаев разрешение на временное пребывание можно получить, если у Вас есть обстоятельства, которые оправдывают ваше пребывание в Польше не менее 3 месяцев. Это самый распространенный способ продлить и легализовать своё пребывание в стране, если истекает ваша виза (безвизовый режим) или предыдущее разрешение на ВНЖ.

🔸️Разрешение на временное пребывание в Польше имеет срок действия не более 3-х лет. При получении такого разрешения, выдаётся пластиковая карта, которую в Польше принято называть картой побыта. Благодаря действующей карте и паспорту, можно свободно выезжать в другие страны Шенгенской зоны на 90 дней в течение последующих 180 дней, отсчитываемых от первого дня въезда в другую страну Шенгенской зоны.

🔸️Требования для получения ВНЖ очень разнообразны и напрямую зависят от основания, по которому вы хотите остаться в Польше. Одними из самых популярных оснований являются: работа, учёба, воссоединение семьи и ведение бизнеса. Одно из главных требований, которое относиться почти ко всем желающим подать заявление на ВНЖ - находиться на территории Польши и находиться на ней легально. То есть, нужно успеть подать заявление до истечения последнего дня визы или любого другого разрешения на пребывание в стране.

Как правило, заявление на ВНЖ нужно подавать лично по предварительной записи в Воеводском управлении. Вы можете также отправить заявление почтой на адрес управления или в специальном бюро документов (без предварительной записи). В таком случае Орган вызовет вас в управление отдельным письмом для снятия отпечатков пальцев. Исключением является ситуация, когда получение ВНЖ касается не вас лично, а члена вашей семьи, за которого вы подавали заявление (т.е. в случае процедуры по воссоединению семьи). В этом случае снятие отпечатков пальцев произойдет в момент получения им карты побыту.

Рассмотрение дела по ВНЖ почти всегда является платным и эта сумма зависит непосредственно от основания подачи заявления. В случае выдачи негативного решение по делу, вы можете подать заявление на возврат этой оплаты. Для этого нужно сохранить подтверждение оплаты, копию которого нужно будет предоставить в случае желания возврата.
      `,
      publishedDate: new Date('2023-05-15'),
      image: '/img/postsImages/post4.jpg',
    },
    {
      id: '3',
      title: 'Международная защита',
      shortDescription: '',
      content: `
Международная защита (далее как: межд. защита) - это специальная институция, созданная для защиты прав человека в случае, если они были нарушены в стране происхождения, и человек вынужден искать убежище в другой стране.

Существуют два вида межд. защиты: статус беженца и дополнительная защита.

Часто понятие “статус беженца” (по-польски: status uchodźcy) путают с понятием “убежища” (по-польски: azyl). Это происходит из-за того, что в разговорной речи мы часто используем слово “беженец”, чтобы описать сложную жизненную ситуацию человека, который обязан был покинуть свою страну, однако профессиональные юридические названия часто отличаются от разговорных.

🔸️По своей сути, межд. защита - один из способов легализовать своё длительное пребывание на территории Польши. Главным основанием получить межд. защиту являются обоснованные опасения, что заявитель подвергнется преследованию или серьезному вреду в своей стране и/или он не может или не хочет воспользоваться защитой в своей стране. При соблюдении формальных правил процедуры предоставления межд. защиты, правдивости истории иностранца, желательно подтвержденной достоверными доказательствами, больше ничего не требуется. Заявление на межд. защиту можно подать на территории Польши или на любом пограничном пункте. Важно отметить, что эта форма защиты была создана для людей, у которых нет гражданства страны-члена ЕС. Кроме того, подать заявление на предоставление межд. защиты можно не имея никакого гражданства вообще и/или не имея никакого подтверждающего личность документа, напр. паспорта. В некоторых случаях, если личность не удаётся подтвердить никакими другими документами, Орган может запросить информацию о подтверждение личности в предполагаемую страну происхождения иностранца, что может увеличить процесс рассмотрения дела.

Процедура предоставления межд. защиты является бесплатной, более того, в ходе процедуры заявитель имеет право на социальную помощь, т.е. бесплатную медицинскую помощь, питание, жильё, деньги на карманные расходы и тд. Важно заметить, что законодательно рассмотрение дела о межд. защите может длиться до 6 месяцев (с возможностью продления этого срока) и в первые 6 месяцев, заявитель не имеет права официально трудоустроиться. Если же Орган не выдал решения в течение 6 месяцев, то он обязан выдать разрешение на работу. Подача заявления на межд. защиту связана также ещё с одним важным ограничением: в течение всей процедуры рассмотрения дела по межд. защите нельзя покидать территорию страны, в которой вы подали заявление. С этой целью у заявителя даже забирают удостоверяющий личность документ (если он есть) и дают взамен временное удостоверение личности.

Эта только маленькая часть информации, которую нужно знать об этой процедуре :) В дальнейшем постараемся ещё более подробно раскрыть тему межд. защиты ❤️

Статья основана на законе - Ustawa z dnia 13 czerwca 2003 r. o udzielaniu cudzoziemcom ochrony na terytorium Rzeczypospolitej Polskiej 
      `,
      publishedDate: new Date('2023-05-07'),
      image: '/img/postsImages/post3.jpg',
    },
    {
      id: '2',
      title: 'Исключения в спец законе',
      shortDescription: '',
      content: `
Мы уже рассказывали о том, кто является основным адресатом специального закона о помощи гражданам Украины.
☝️Однако закон предусматривает исключения, касающиеся некоторых категорий лиц. Эта статья посвящена теме, какие группы граждан Украины не будут подпадать под действие закона, даже при соблюдении условий, указанных в предыдущем посте.

Положения специального закона не распространяются на граждан Украины, которые:

1️⃣ имеют:

- разрешение на постоянное проживание,

- вид на жительство долгосрочного резидента Европейского Союза,

- разрешение на временное проживание,

- статус беженца,

- дополнительную защиту,

- разрешение на толерантное пребывание,

- разрешение на пребывание по гуманитарным причинам;

2️⃣ а также на граждан, которые:

- подали заявление на предоставление международной защиты в Польше,

- заявили о своем намерении подать заявление на предоставление международной защиты в Польше,

- уже пользуются временной защитой на территории государства-члена Европейского Союза, кроме Республики Польша, предоставленной в связи с военными действиями, проводимыми на территории Украины.

❗️Важно отметить, что подача заявления на предоставление разрешения на постоянное/временное проживание или вид на жительство долгосрочного резидента Европейского Союза не влечет за собой утраты права находиться в Польше легально до 23 августа 2023 года. То же самое касается граждан, которые отзовут заявление о предоставлении международной защиты или заявление о намерении подать просьбу на международную защиту.

Статья основана на законе - Ustawa z dnia 12 marca 2022 r. o pomocy obywatelom Ukrainy w związku z konfliktem zbrojnym na terytorium
      `,
      publishedDate: new Date('2023-05-03'),
      image: '/img/postsImages/post2.jpg',
    },
    {
      id: '1',
      title: 'Кому адресован спец закон о помощи гражданам Украины?',
      shortDescription: '',
      content: `
Согласно спец закону можно выделить три основные категории адресатов.

🔸В первую очередь это, конечно, граждане Украины, которые пересекли границу с Польшей после 24 февраля 2022 г. в связи с войной на территории Украины.

🔸Второй категорией являются их супруги. Во всех случаях, когда в спец законе говорится “гражданин Украины”, под ним понимаются также супруги граждан Украины, если они прибыли на территорию Польши непосредственно с территории Украины и у них нет гражданства Украины или гражданства государства-члена Европейского Союза.
Это положение не дает права разведенным лицам, которые в настоящее время не состоят в браке с гражданином Украины.

🔸Третьей категорией можно назвать граждан Украины с Картой Поляка (далее как: КП), а также их близких членов семьи. Важно заметить, что обладатели КП и их близкие (которые могут и не иметь КП) не обязаны приезжать в Польшу в связи с войной. На практике это означает, что эта категория граждан может приехать в Польшу из любой другой страны, напр. из России или Беларуси, где они ранее проживали, но решили сменить место жительство.
Четкого ответа, кто именно является близким членом семьи в понимании спец закона, нет. В связи с этим, правильнее всего будет опираться на определение из Исполнительного решения Совета ЕС 2022/382, устанавливающее наличие массового притока перемещенных лиц из Украины. В этом положении перечислены: супруг или, в определенных случаях, партнер, с которым бежавшее лицо находится в стабильных неформальных отношениях, несовершеннолетние и зависимые дети, включая детей супруга, и другие близкие родственники, которые проживали вместе как одна семья и которые полностью или частично зависели от лица, бежавшего в то время. Можно сделать вывод, что эту дефиницию следует понимать относительно широко и принимать во внимание фактическое устройство семейных отношений, а не формальный порядок родства, кроме того, такое лицо не обязательно должно быть ближайшим родственником, поскольку родство не является основным или исключительным критерием близости и принадлежности к семье.

Одним из важных условий для близких членов семьи граждан Украины с КП является совместное пересечение границы с Польшей. Закон не будет иметь правовой силы, если границу пересечь отдельно от обладателя КП, чего нельзя сказать о супругах. Супруги граждан Украины имеют независимое право воспользоваться положениями спец закона.

Подводя итог, помимо основной категории адресатов спец закона, т.е. граждан Украины, прибывших на территорию Польшу в связи с войной, адресатами могут быть также люди, не имеющие украинского гражданства, т.е. супруги и близкие члены семьи в случае наличия КП.

Статья основана на законе - Ustawa z dnia 12 marca 2022 r. o pomocy obywatelom Ukrainy w związku z konfliktem zbrojnym na terytorium tego państwa и комментарию к этому закону.
      `,
      publishedDate: new Date('2023-04-17'),
      image: '/img/postsImages/post1.jpg',
    },
  ],

  services: [
    {
      id: 1,
      icon: 'earth-americas',
      title: 'Международная защита',
      shortDescription: 'Если вы вынуждены покинуть свою страну из-за преследований по расовому, религиозному, национальному или иным признакам, вам может быть предоставлена международная защита в Польше.',
      price: '',
    },
    {
      id: 2,
      icon: 'id-card',
      title: 'Получение ВНЖ/ПМЖ',
      shortDescription: 'Если вы хотите продлить своё легальное пребывание в Польше и не хотите делать постоянно новые визы, то получение ВНЖ или ПМЖ будет лучшим вариантом для вас.',
      price: '',
    },
    {
      id: 3,
      icon: 'address-card',
      title: 'Карта резидента EC',
      shortDescription: 'Если вы легально находитесь на территории Польши в течении 5 лет, то вы можете притендовать на получение статуса долгосрочного резидента, что даёт вам возможность легально работать и проживать во всех старнах ЕС.',
      price: '',
    },
    {
      id: 4,
      icon: 'passport',
      title: 'Гражданство',
      shortDescription: 'Если вы хотите стать гражданином Польши, то мы с радостью рассмотрим ваши шансы на получение польского паспорта, а так же поможем в сборе необходимых документов.',
      price: '',
    },
    {
      id: 5,
      icon: 'handshake',
      title: 'Гостевое приглашение',
      shortDescription: 'Если вы хотите сделать документ для ваших близких на основании которого они смогут получить польскую визу, то мы можем помочь вам сделать это в кротчайшие сроки.',
      price: '',
    },
    {
      id: 6,
      icon: 'file-excel',
      title: 'Обжалование решений',
      shortDescription: 'Если вы получили негативное решение по вашему делу, не отчаивайтесь. Наши юристы проверят законность выданного решения и напишут апиляцию.',
      price: '',
    },
    {
      id: 7,
      icon: 'shield-halved',
      title: 'Гуманитарное пребывание',
      shortDescription: 'Если вам небезопасно возвращаться в страну происхождения, то наши юристы помогут ходотайствовать о национальной защите.',
      price: '',
    },
    {
      id: 8,
      icon: 'road-barrier',
      title: 'Депортация',
      shortDescription: 'Если вам грозит депортация из Польши, вы не обязаны с этим мириться. Мы можем предоставить вам юридическую помощь в этом нелёгком процессе.',
      price: '',
    },
    {
      id: 9,
      icon: 'user-tie',
      title: 'Консультация с юристом',
      shortDescription: 'Если вы столкнулись с правовой проблемой, не стоит пытаться решить ее самостоятельно. Наши специалисты предоставят вам квалифицированную юридическую помощь и помогут избежать негативных последствий.',
      price: '',
    },
    {
      id: 10,
      icon: 'stamp',
      title: 'Получение номера PESEL',
      shortDescription: 'Если вам необходимо получить номер PESEL быстро и не тратить своё время, мы можем стать вашим доверенным лицом чтобы решить всё за вас.',
      price: '',
    },
    {
      id: 11,
      icon: 'pen-to-square',
      title: 'Заполнение заявлений',
      shortDescription: 'Если вы столкнулись с необходимостью заполнения заявления, но не уверены, как это сделать правильно, не отчаивайтесь. Мы можем помочь вам заполнить заявление быстро и без ошибок.',
      price: '',
    },
    {
      id: 12,
      icon: 'file-signature',
      title: 'Написание писем',
      shortDescription: 'Если вам надо написать убедительное и эффективное письмо административному органу или суду, то наши специалисты с многолетним опытом работы в сфере юриспруденции помогут вам.',
      price: '',
    },
    {
      id: 13,
      icon: 'people-roof',
      title: 'Прописка (Meldunek)',
      shortDescription: 'Если вы планируете находиться в Польше более 30 дней, вам необходимо оформить прописку (мельдунек). Мы можем сделать это быстро и съэкономить ваше время.',
      price: '',
    },
    {
      id: 14,
      icon: 'eye',
      title: 'Изучение и фотокопия документов',
      shortDescription: 'Если вам необходимо изучить или сделать копию документов в административных органах, но вы не хотите тратить на это свое время, мы поможем сделать это быстро и без проблем получить необходимые документы.',
      price: '',
    },
    {
      id: 15,
      icon: 'car',
      title: 'Регистрация автомобиля',
      shortDescription: 'Если вы купили автомобиль и вам нужна помощь в его зарегистрации. Это может быть сложным и трудоемким процессом, особенно если вы не знакомы с законодательством. Мы можем помочь вам сделать это быстро и без проблем.',
      price: '',
    },
    {
      id: 16,
      icon: 'right-left',
      title: 'Транскрипция документов',
      shortDescription: 'Если вам требуется транскрипция документа для подачи на гражданство, то мы можем взять весь процесс под свой контроль, сделаем в кротчайшие сроки и предоставим вам готовые документы.',
      price: '',
    },
    {
      id: 17,
      icon: 'circle-info',
      title: 'Другое',
      shortDescription: 'Это только основной список наших услуг! Если в списке нет того, что вам нужно, не отчаивайтесь! Наша команда опытных юристов готова рассмотреть вашу ситуацию индивидуально.',
      price: '',
    },
  ],
};

export default initialState;